"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _parsing = require("@/utils/parsing");
var _store = require("@/api/store");
var _categoryApi = require("@/api/categoryApi");
var _Editor = _interopRequireDefault(require("./Editor.vue"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'index',
  components: {
    Editor: _Editor.default
  },
  data: function data() {
    return {
      list: [],
      queryParams: {
        name: '',
        status: '',
        limit: 20,
        page: 1
      },
      total: 0,
      statusOptions: {
        0: '正常',
        1: '暂停'
      },
      categories: []
    };
  },
  computed: {
    categoriesObj: function categoriesObj() {
      return (0, _parsing.extractIdAndName)(this.categories);
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.getCategories();
          case 1:
            this.getList();
          case 2:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    checkPermi: _permission.checkPermi,
    getCategories: function () {
      var _getCategories = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _categoryApi.treeCategroy)({
                type: 1,
                status: -1
              });
            case 1:
              this.categories = _context2.v;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getCategories() {
        return _getCategories.apply(this, arguments);
      }
      return getCategories;
    }(),
    getList: function getList() {
      var _this = this;
      var params = (0, _parsing.filterValidParams)(this.queryParams);
      (0, _store.getFictiTaskList)(params).then(function (res) {
        _this.total = res.total;
        _this.list = res.list;
      });
    },
    onQuery: function onQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    onReset: function onReset() {
      this.$refs.queryFormRef.resetFields();
      this.onQuery();
    },
    onPageChange: function onPageChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    onSizeChange: function onSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    onEdit: function onEdit(data) {
      this.$refs.editorRef.open(data);
    },
    onEditSuccess: function onEditSuccess(isNew) {
      if (isNew) {
        this.onReset();
      } else {
        this.getList();
      }
    },
    onDelete: function () {
      var _onDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
        var _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return this.$confirm("\u662F\u5426\u5220\u9664\u4EFB\u52A1\u3010".concat(data.name, "\u3011?"), '确认删除');
            case 1:
              _context3.n = 2;
              return (0, _store.deleteFictiTask)(data.id);
            case 2:
              this.$message.success('删除成功');
              this.getList();
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t = _context3.v;
              console.error("\u5220\u9664\u4EFB\u52A1".concat(data.name), _t);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 3]]);
      }));
      function onDelete(_x) {
        return _onDelete.apply(this, arguments);
      }
      return onDelete;
    }(),
    getCategoryNames: function getCategoryNames(ids) {
      var _this2 = this;
      var arr = [];
      ids.forEach(function (id) {
        var name = _this2.categoriesObj[id] || '已删除';
        name += "\uFF08".concat(id, "\uFF09");
        arr.push(name);
      });
      return arr.join(', ');
    },
    onStart: function () {
      var _onStart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
        var _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return this.$confirm("\u662F\u5426\u542F\u52A8\u4EFB\u52A1\u3010".concat(data.name, "\u3011?"), '确认');
            case 1:
              _context4.n = 2;
              return (0, _store.fictiTaskStart)(data.id);
            case 2:
              this.$message.success('启动成功');
              this.getList();
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t2 = _context4.v;
              console.error("\u542F\u52A8\u4EFB\u52A1".concat(data.name), _t2);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 3]]);
      }));
      function onStart(_x2) {
        return _onStart.apply(this, arguments);
      }
      return onStart;
    }(),
    onStop: function () {
      var _onStop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data) {
        var _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return this.$confirm("\u662F\u5426\u6682\u505C\u4EFB\u52A1\u3010".concat(data.name, "\u3011?"), '确认');
            case 1:
              _context5.n = 2;
              return (0, _store.fictiTaskStop)(data.id);
            case 2:
              this.$message.success('暂停成功');
              this.getList();
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
              console.error("\u6682\u505C\u4EFB\u52A1".concat(data.name), _t3);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 3]]);
      }));
      function onStop(_x3) {
        return _onStop.apply(this, arguments);
      }
      return onStop;
    }(),
    onExecute: function () {
      var _onExecute = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(data) {
        var _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return this.$confirm("\u662F\u5426\u7ACB\u5373\u6267\u884C\u4EFB\u52A1\u3010".concat(data.name, "\u3011?"), '确认');
            case 1:
              _context6.n = 2;
              return (0, _store.fictiTaskRun)(data.id);
            case 2:
              this.$message.success('执行成功');
              this.getList();
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t4 = _context6.v;
              console.error("\u7ACB\u5373\u6267\u884C\u4EFB\u52A1".concat(data.name), _t4);
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 3]]);
      }));
      function onExecute(_x4) {
        return _onExecute.apply(this, arguments);
      }
      return onExecute;
    }()
  }
};